import { CURRENCY_LIST, LOCALIZATION_LIST } from 'config/constants'
import { useTranslation } from 'contexts/Localization'
import { setCurrency } from 'state/app/actions'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Language } from '../../../packages/uikit/src/components/LangSelector/types'

const Wrapper = styled.div``

const HoverInfo = styled.div`
  &.hover-info {
    position: absolute;
    padding: 12px;
    top: 42px;
    right: 0px;
    width: 320px;
    min-height: 260px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    opacity: 1;
    transition: 0.2s;

    .hover-info-content {
      font-size: 14px;
      font-weight: bold;
      min-width: 233px;
      color: black;
      .hover-info-content-items {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        .hover-info-content-item {
          width: 48%;
          display: flex;
          padding: 6px;
          border-radius: 8px;
          cursor: pointer;
          margin: 6px 0;
          background-color: transparent;
          border: none;
          font-weight: bold;
          div {
            display: flex;
            align-items: center;
            padding: 6px 12px;
            gap: 8px;
            width: 100%;
            img {
              width: 26px;
              height: 26px;
              border-radius: 50%;
            }
          }
        }
        .active {
          background-color: rgba(0, 109, 254, 0.2);
          color: blue;
          border-radius: 26px;
        }
        .hover-info-content-header {
          justify-content: center;
          border-radius: 12px;
          padding: 12px;
          margin: 3px;
          width: 45%;
        }
        .header-active {
          background-color: blue;
          color: white;
        }
      }
    }
  }
  @media (max-width: 1024px) {
    &.hover-info {
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`
interface Currency {
  flag: string
  name: string
  abbreviation: string
  symbol: string
  icon: string // Thêm trường "icon" vào kiểu dữ liệu của phần tử trong mảng
}

interface LanguageFormat {
  flag: string
  lang: string
  icon: string // Thêm trường "icon" vào kiểu dữ liệu của phần tử trong mảng
}

const DataSelected = ({ setIsHovered, isTypeLanguage, setIsTypeLanguage, isTypeCurrency, setIsTypeCurrency }) => {
  const dispatch = useDispatch()

  const [isSelectLanguage, setIsSelectLanguage] = useState<boolean>(true)
  const [isSelectCurrency, setIsSelectCurrency] = useState<boolean>(false)

  const [listCurrency, setListCurrency] = useState<Currency[]>([])
  const [listLanguage, setListLanguage] = useState<LanguageFormat[]>([])

  const { t, setLanguage } = useTranslation()

  // update google translate selector
  const onChangeLocalize = (flag) => {
    const localize = LOCALIZATION_LIST.filter((x) => x.flag === flag)
    localStorage.setItem('localize', JSON.stringify(localize[0]))
    const dataLanguage = {
      code: localize[0].lang,
      language: localize[0].lang,
      locale: localize[0].lang,
    } as Language

    setLanguage(dataLanguage)
  }

  // update currency selector
  const onChangeLocalizeCurrency = (flag) => {
    localStorage.setItem('currency', flag)
    dispatch(setCurrency(flag))
  }

  useEffect(() => {
    let formatListCurrency: Currency[] = []

    let formatListLanguage: LanguageFormat[] = []

    formatListCurrency = CURRENCY_LIST?.map((currency) => {
      let icon = '/images/icons/usd.svg' // Biểu tượng mặc định

      switch (currency.flag) {
        case 'US':
          icon = '/images/icons/usd.svg'
          break
        case 'VN':
          icon = '/images/icons/vnd.svg'
          break
        case 'BG':
          icon = '/images/icons/euro.svg'
          break
        default:
          break
      }

      return { ...currency, icon } // Trả về đối tượng với giá trị icon đã cập nhật
    })

    formatListLanguage = LOCALIZATION_LIST?.map((language) => {
      let icon = '/images/icons/flag_usa.svg' // Biểu tượng mặc định
      let lang = 'English' // Ngôn ngữ mặc định

      switch (language.flag) {
        case 'US':
          icon = '/images/icons/flag_usa.svg'
          lang = 'English'
          break
        case 'VN':
          icon = '/images/icons/flag_vn.svg'
          lang = 'Tiếng Việt'
          break
        case 'CN':
          icon = '/images/icons/flag_cn.svg'
          lang = 'Chinese'
          break
        default:
          break
      }

      return { ...language, icon, lang } // Trả về đối tượng với giá trị icon và lang đã cập nhật
    })

    setListCurrency(formatListCurrency)
    setListLanguage(formatListLanguage)
  }, [])

  return (
    <HoverInfo className="hover-info" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className="hover-info-content">
        <div className="hover-info-content-items ">
          <button
            type="button"
            className={
              isSelectLanguage
                ? 'hover-info-content-item hover-info-content-header  header-active'
                : 'hover-info-content-item hover-info-content-header '
            }
            onClick={() => {
              setIsSelectLanguage(true)
              setIsSelectCurrency(false)
            }}
          >
            <p>{t('Ngôn ngữ')}</p>
          </button>

          <button
            type="button"
            className={
              isSelectCurrency
                ? 'hover-info-content-item hover-info-content-header  header-active'
                : 'hover-info-content-item hover-info-content-header '
            }
            onClick={() => {
              setIsSelectLanguage(false)
              setIsSelectCurrency(true)
            }}
          >
            <p>{t('Tiền tệ')}</p>
          </button>

          {isSelectLanguage ? (
            <>
              {listLanguage?.length > 0 &&
                listLanguage?.map((language) => (
                  <button
                    type="button"
                    className={
                      isTypeLanguage === language.flag ? 'hover-info-content-item  active' : 'hover-info-content-item '
                    }
                    onClick={() => {
                      setIsTypeLanguage(language.flag)
                      onChangeLocalize(language.flag)
                    }}
                  >
                    <div>
                      <img src={language.icon} alt="icon-earth" />
                      <p>{language.lang}</p>
                    </div>
                  </button>
                ))}
            </>
          ) : (
            <>
              {listCurrency?.length > 0 &&
                listCurrency?.map((currency) => (
                  <button
                    type="button"
                    className={
                      isTypeCurrency === currency.abbreviation
                        ? 'hover-info-content-item  active'
                        : 'hover-info-content-item '
                    }
                    onClick={() => {
                      setIsTypeCurrency(currency.abbreviation)
                      onChangeLocalizeCurrency(currency.flag)
                    }}
                  >
                    <div>
                      <img src={currency.icon} alt="icon-earth" />
                      <p>{currency.abbreviation}</p>
                    </div>
                  </button>
                ))}
            </>
          )}
        </div>
      </div>
    </HoverInfo>
  )
}

const LanguageSelectorItem = ({
  setIsHovered,
  isTypeLanguage,
  setIsTypeLanguage,
  isTypeCurrency,
  setIsTypeCurrency,
  ...props
}) => {
  const { t } = useTranslation()
  const hoverRef = useRef(null)
  const [positionHover, setPositionHover] = useState<any>('topLeft')

  useEffect(() => {
    if (hoverRef?.current) {
      window.addEventListener('scroll', () => {
        if (hoverRef?.current?.getBoundingClientRect().y - 350 < 0) {
          setPositionHover('bottomLeft')
        } else {
          setPositionHover('topLeft')
        }
      })
    }
  }, [])

  return (
    <div>
      <DataSelected
        setIsHovered={setIsHovered}
        isTypeLanguage={isTypeLanguage}
        setIsTypeLanguage={setIsTypeLanguage}
        isTypeCurrency={isTypeCurrency}
        setIsTypeCurrency={setIsTypeCurrency}
      />
    </div>
  )
}

export default LanguageSelectorItem
